export const PRIMARY_COLOR = "#1e22aa";
export const WHITE = "#fff";
export const ON_HOVER_BACKGROUND_COLOR = "#E31C79";
export const REST_BACKGROUND_COLOR = "#EEC643";
